module.exports = "/static/assets/6254575e75d05fe637cc61b7197c2123.png";